import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useBlockedBy } from "../../hooks/useBlockedBy";
import { RuleResult } from "./RuleResult";

interface BlockedByListProps {
  isSameCustomer: boolean;
}

export function BlockedByList({ isSameCustomer }: BlockedByListProps) {
  const { t } = useTranslation();
  const { blockList } = useBlockedBy();

  return (
    <>
      <Typography color="text.low" sx={{ letterSpacing: 0 }} variant="button">
        {t("Blocked by")}
      </Typography>
      {blockList?.ruleResults.map((rule) => (
        <RuleResult
          key={rule.id}
          bank={blockList.bank}
          data-testid={`transaction-details-risk-overview-blocked-by-${rule.type}`}
          isSameCustomer={isSameCustomer}
          rule={rule}
        />
      ))}
    </>
  );
}
